import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { deleteReportRule } from '../services/reportRuleService';

const DeleteReportRuleModal = forwardRef(({ onDelete }, ref) => {
  const [show, setShow] = useState(false);
  const [rule, setRule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useImperativeHandle(ref, () => ({
    show: (reportRule) => {
      setRule(reportRule);
      setShow(true);
      setError(null);
    },
  }));

  const handleClose = () => {
    setShow(false);
    setRule(null);
    setError(null);
  };

  const handleConfirmDelete = async () => {
    if (!rule) return;
    setLoading(true);
    setError(null);
    try {
      await deleteReportRule(rule.id);
      handleClose();
      onDelete();
    } catch (err) {
      setError(err.message || 'Failed to delete report rule');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-warning" />
          Confirm Delete
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && (
          <Alert variant="danger" dismissible onClose={() => setError(null)}>
            {error}
          </Alert>
        )}
        <p>
          Are you sure you want to delete the report rule{' '}
          <strong>"{rule?.name}"</strong>?
        </p>
        <p className="text-muted mb-0">
          This action cannot be undone. The report rule and its schedule will be permanently removed.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirmDelete} disabled={loading}>
          {loading ? 'Deleting...' : 'Delete Report Rule'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default DeleteReportRuleModal;